import { EndpointPermissionRule } from '../core/permissions/endpoint-permission.models';

import {

  P,

  SU_AYAK_IZI_FEATURE_PERMISSIONS,

} from './portal-permissions.constants';



const WATER_READ = [...SU_AYAK_IZI_FEATURE_PERMISSIONS];

const WATER_WRITE = [

  P.SuAyakIzi.CekilenSu,

  P.SuAyakIzi.YagmurSuyu,

  P.SuAyakIzi.AritilanSu,

];



function multiRead(

  pattern: string,

  permissionKeys: string[],

  methods: ('GET' | 'POST')[] = ['GET', 'POST'],

): EndpointPermissionRule[] {

  return methods.map((method) => ({

    method,

    pattern,

    permissionKeys,

    access: 'read' as const,

  }));

}



function multiWrite(

  pattern: string,

  permissionKeys: string[],

  methods: ('GET' | 'POST')[] = ['POST'],

): EndpointPermissionRule[] {

  return methods.map((method) => ({

    method,

    pattern,

    permissionKeys,

    access: 'write' as const,

  }));

}



/** Su Ayak İzi — alt özellik key'leri (Genel / Çekilen / Yağmur / Arıtılan). */

export const SU_AYAK_IZI_ENDPOINT_EXTRA_RULES: readonly EndpointPermissionRule[] =

  [

    ...multiRead('api/Water/GetWaterFootprintSummary', [P.SuAyakIzi.Genel], [

      'GET',

    ]),



    ...multiRead('api/Water/GetWaterFootprints', WATER_READ, ['GET']),

    ...multiRead('api/Water/GetWaterSupplies', WATER_READ, ['GET']),

    ...multiRead('api/Water/GetEffluentPointTypes', WATER_READ, ['GET']),



    ...multiRead(

      'api/Water/GetWaterTreatmentPlantTypes',

      [...WATER_READ, P.Yonetim.AtiksuTesisleri],

      ['GET'],

    ),

    ...multiRead(

      'api/Water/GetWaterTreatmentPlants',

      [...WATER_READ, P.Yonetim.AtiksuTesisleri],

      ['GET'],

    ),

    ...multiRead(

      'api/Water/GetWaterTransmissionPaths',

      [...WATER_READ, P.Yonetim.AtiksuTesisleri],

      ['GET'],

    ),



    ...multiWrite('api/Water/CreateWaterFootprint', WATER_WRITE),

    ...multiWrite('api/Water/UpdateWaterFootprint', WATER_WRITE),

    ...multiWrite('api/Water/DeleteWaterFootprint', WATER_WRITE),



    /** Lokasyon ağacı — su formları */

    ...multiRead('api/Company/GetLocations', [

      ...WATER_READ,

      P.Yonetim.Lokasyonlar,

      P.Yonetim.AtiksuTesisleri,

      P.Hesaplama.VeriGirisi,

    ]),

  ];


